(function () {
  'use strict';

  var OPEN_CLASS = 'is-open';
  var ACTIVE_CLASS = 'is-active';
  var CLOSE_DELAY_MS = 250;
  var SCROLL_KEYS = [' ', 'Spacebar', 'PageUp', 'PageDown', 'ArrowUp', 'ArrowDown', 'Home', 'End'];

  function getFocusableElements(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href]:not([aria-disabled="true"]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function isScrollableElement(element) {
    if (!element || element === document.body || element === document.documentElement) {
      return false;
    }

    var style = window.getComputedStyle(element);
    var overflowY = style.overflowY;

    if (overflowY !== 'auto' && overflowY !== 'scroll') {
      return element.parentElement ? isScrollableElement(element.parentElement) : false;
    }

    return element.scrollHeight > element.clientHeight;
  }

  function SangDouleurHeader(sectionRoot) {
    this.root = sectionRoot;
    this.openButton = sectionRoot.querySelector('[data-sangdouleur-header-menu-open]');
    this.closeButtons = sectionRoot.querySelectorAll('[data-sangdouleur-header-mega-close]');
    this.megaMenu = sectionRoot.querySelector('.sangdouleur-header__mega-menu');
    this.overlay = sectionRoot.querySelector('[data-sangdouleur-header-mega-overlay]');
    this.panel = sectionRoot.querySelector('[data-sangdouleur-header-mega-panel]');
    this.menuItems = sectionRoot.querySelectorAll('[data-sangdouleur-mega-item]');
    this.menuLinks = sectionRoot.querySelectorAll('.sangdouleur-header__mega-link');
    this.menuPanels = sectionRoot.querySelectorAll('[data-sangdouleur-mega-panel]');
    this.drawerTriggers = sectionRoot.querySelectorAll('[data-sangdouleur-drawer-trigger]');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    this.closeOnOutsideClick = sectionRoot.dataset.sangdouleurCloseOutside === 'true';
    this.isClosing = false;
    this.scrollBlockersActive = false;
    this.closeTimer = null;
    this.openFrame = null;
    this.lastFocusedElement = null;

    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.onOverlayClick = this.onOverlayClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onFocusTrap = this.onFocusTrap.bind(this);
    this.onWheel = this.onWheel.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onItemActivate = this.onItemActivate.bind(this);
    this.onDrawerTriggerClick = this.onDrawerTriggerClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
  }

  SangDouleurHeader.prototype.isOpen = function () {
    return this.megaMenu && this.megaMenu.classList.contains(OPEN_CLASS);
  };

  SangDouleurHeader.prototype.isMenuVisible = function () {
    return this.megaMenu && !this.megaMenu.hidden;
  };

  SangDouleurHeader.prototype.clearTimers = function () {
    if (this.closeTimer) {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    if (this.openFrame) {
      window.cancelAnimationFrame(this.openFrame);
      this.openFrame = null;
    }
  };

  SangDouleurHeader.prototype.init = function () {
    if (!this.openButton || !this.megaMenu || this.root.dataset.sangdouleurHeaderInit === 'true') {
      return;
    }

    this.root.dataset.sangdouleurHeaderInit = 'true';

    this.openButton.addEventListener('click', this.onToggle);
    this.closeButtons.forEach(
      function (button) {
        button.addEventListener('click', this.onClose);
      }.bind(this)
    );
    this.overlay?.addEventListener('click', this.onOverlayClick);

    this.menuLinks.forEach(
      function (link) {
        if (this.desktopMediaQuery.matches) {
          link.addEventListener('mouseenter', this.onItemActivate);
        }
        link.addEventListener('focusin', this.onItemActivate);
      }.bind(this)
    );

    this.drawerTriggers.forEach(
      function (trigger) {
        trigger.addEventListener('click', this.onDrawerTriggerClick);
      }.bind(this)
    );

    if (this.menuItems.length) {
      this.activatePanel(this.menuItems[0].getAttribute('data-sangdouleur-mega-item'));
    }
  };

  SangDouleurHeader.prototype.destroy = function () {
    this.openButton?.removeEventListener('click', this.onToggle);
    this.closeButtons?.forEach(
      function (button) {
        button.removeEventListener('click', this.onClose);
      }.bind(this)
    );
    this.overlay?.removeEventListener('click', this.onOverlayClick);
    this.menuLinks?.forEach(
      function (link) {
        link.removeEventListener('mouseenter', this.onItemActivate);
        link.removeEventListener('focusin', this.onItemActivate);
      }.bind(this)
    );
    this.drawerTriggers?.forEach(
      function (trigger) {
        trigger.removeEventListener('click', this.onDrawerTriggerClick);
      }.bind(this)
    );

    this.clearTimers();
    this.removeOutsideClickListener();
    this.removeScrollBlockers();
    this.resetMenuState();

    if (this.megaMenu) {
      this.megaMenu.hidden = true;
    }
  };

  SangDouleurHeader.prototype.resetMenuState = function () {
    if (!this.megaMenu) {
      return;
    }

    this.isClosing = false;
    this.megaMenu.classList.remove(OPEN_CLASS);
    this.megaMenu.setAttribute('aria-hidden', 'true');
    this.openButton?.setAttribute('aria-expanded', 'false');
  };

  SangDouleurHeader.prototype.addScrollBlockers = function () {
    if (this.scrollBlockersActive) {
      return;
    }

    document.addEventListener('keydown', this.onKeydown);
    document.addEventListener('keydown', this.onFocusTrap);
    window.addEventListener('wheel', this.onWheel, { passive: false, capture: true });
    window.addEventListener('touchmove', this.onTouchMove, { passive: false, capture: true });
    this.scrollBlockersActive = true;
  };

  SangDouleurHeader.prototype.removeScrollBlockers = function () {
    if (!this.scrollBlockersActive) {
      return;
    }

    document.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('keydown', this.onFocusTrap);
    window.removeEventListener('wheel', this.onWheel, { capture: true });
    window.removeEventListener('touchmove', this.onTouchMove, { capture: true });
    this.scrollBlockersActive = false;
  };

  SangDouleurHeader.prototype.shouldAllowScroll = function (target) {
    if (!target) {
      return false;
    }

    if (this.panel && this.panel.contains(target) && isScrollableElement(target)) {
      return true;
    }

    var drawerScroll = this.root.querySelector('.sangdouleur-header__mega-drawer-scroll');
    if (drawerScroll && drawerScroll.contains(target) && isScrollableElement(target)) {
      return true;
    }

    return false;
  };

  SangDouleurHeader.prototype.activatePanel = function (blockId) {
    if (!blockId) {
      return;
    }

    this.menuItems.forEach(function (item) {
      var isActive = item.getAttribute('data-sangdouleur-mega-item') === blockId;
      item.classList.toggle(ACTIVE_CLASS, isActive);
    });

    this.menuPanels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-sangdouleur-mega-panel') === blockId;
      panel.classList.toggle(ACTIVE_CLASS, isActive);
      panel.hidden = !isActive;
    });
  };

  SangDouleurHeader.prototype.onDrawerTriggerClick = function (event) {
    var trigger = event.currentTarget;
    var section = trigger.closest('.sangdouleur-header__mega-drawer-section');
    var panel = section ? section.querySelector('[data-sangdouleur-drawer-panel]') : null;
    var isExpanded = trigger.getAttribute('aria-expanded') === 'true';

    if (!panel) {
      return;
    }

    trigger.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    trigger.classList.toggle(ACTIVE_CLASS, !isExpanded);
    panel.hidden = isExpanded;
  };

  SangDouleurHeader.prototype.onItemActivate = function (event) {
    var link = event.currentTarget;
    var item = link.closest('[data-sangdouleur-mega-item]');

    if (!item) {
      return;
    }

    this.activatePanel(item.getAttribute('data-sangdouleur-mega-item'));
  };

  SangDouleurHeader.prototype.addOutsideClickListener = function () {
    if (!this.closeOnOutsideClick) {
      return;
    }

    window.requestAnimationFrame(
      function () {
        document.addEventListener('click', this.onDocumentClick, true);
      }.bind(this)
    );
  };

  SangDouleurHeader.prototype.removeOutsideClickListener = function () {
    document.removeEventListener('click', this.onDocumentClick, true);
  };

  SangDouleurHeader.prototype.onDocumentClick = function (event) {
    if (!this.isOpen()) {
      return;
    }

    if (this.openButton && this.openButton.contains(event.target)) {
      return;
    }

    if (this.panel && this.panel.contains(event.target)) {
      return;
    }

    this.onClose();
  };

  SangDouleurHeader.prototype.onToggle = function () {
    if (this.isOpen()) {
      this.onClose();
      return;
    }

    if (this.isClosing) {
      this.onOpen();
      return;
    }

    if (this.isMenuVisible()) {
      this.onClose();
      return;
    }

    this.onOpen();
  };

  SangDouleurHeader.prototype.onOpen = function () {
    if (!this.megaMenu) {
      return;
    }

    this.clearTimers();
    this.isClosing = false;
    this.lastFocusedElement = document.activeElement;

    this.megaMenu.hidden = false;
    this.megaMenu.setAttribute('aria-hidden', 'false');
    this.openButton.setAttribute('aria-expanded', 'true');
    this.addScrollBlockers();
    this.addOutsideClickListener();

    if (this.menuItems.length) {
      this.activatePanel(this.menuItems[0].getAttribute('data-sangdouleur-mega-item'));
    }

    this.openFrame = window.requestAnimationFrame(
      function () {
        this.openFrame = null;
        this.megaMenu.classList.add(OPEN_CLASS);
      }.bind(this)
    );
  };

  SangDouleurHeader.prototype.onClose = function () {
    if (!this.megaMenu || !this.isMenuVisible()) {
      return;
    }

    this.clearTimers();
    this.isClosing = true;
    this.megaMenu.classList.remove(OPEN_CLASS);
    this.megaMenu.setAttribute('aria-hidden', 'true');
    this.openButton.setAttribute('aria-expanded', 'false');
    this.removeOutsideClickListener();
    this.removeScrollBlockers();

    this.closeTimer = window.setTimeout(
      function () {
        this.closeTimer = null;
        this.megaMenu.hidden = true;
        this.isClosing = false;

        if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === 'function') {
          this.lastFocusedElement.focus();
        } else {
          this.openButton.focus();
        }
      }.bind(this),
      CLOSE_DELAY_MS
    );
  };

  SangDouleurHeader.prototype.onOverlayClick = function (event) {
    if (event.target === this.overlay) {
      this.onClose();
    }
  };

  SangDouleurHeader.prototype.onKeydown = function (event) {
    if (!this.isOpen()) {
      return;
    }

    if (event.key === 'Escape') {
      this.onClose();
      return;
    }

    if (SCROLL_KEYS.indexOf(event.key) === -1) {
      return;
    }

    if (this.shouldAllowScroll(event.target)) {
      return;
    }

    event.preventDefault();
  };

  SangDouleurHeader.prototype.onWheel = function (event) {
    if (!this.isOpen() || this.shouldAllowScroll(event.target)) {
      return;
    }

    event.preventDefault();
  };

  SangDouleurHeader.prototype.onTouchMove = function (event) {
    if (!this.isOpen() || this.shouldAllowScroll(event.target)) {
      return;
    }

    event.preventDefault();
  };

  SangDouleurHeader.prototype.onFocusTrap = function (event) {
    if (event.key !== 'Tab' || !this.isOpen() || !this.panel) {
      return;
    }

    var focusable = getFocusableElements(this.panel);
    if (!focusable.length) {
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  var instances = new WeakMap();

  function initHeader(sectionRoot) {
    if (!sectionRoot) {
      return;
    }

    var existing = instances.get(sectionRoot);
    if (existing) {
      existing.destroy();
    }

    var instance = new SangDouleurHeader(sectionRoot);
    instance.init();
    instances.set(sectionRoot, instance);
  }

  function initAllHeaders() {
    document.querySelectorAll('sangdouleur-header.sangdouleur-header').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHeaders);
  } else {
    initAllHeaders();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionRoot = event.target.querySelector('sangdouleur-header.sangdouleur-header');

    if (!sectionRoot && event.target.matches('sangdouleur-header.sangdouleur-header')) {
      sectionRoot = event.target;
    }

    initHeader(sectionRoot);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionRoot = event.target.querySelector('sangdouleur-header.sangdouleur-header');

    if (!sectionRoot && event.target.matches('sangdouleur-header.sangdouleur-header')) {
      sectionRoot = event.target;
    }

    var existing = instances.get(sectionRoot);
    if (existing) {
      existing.destroy();
      instances.delete(sectionRoot);
    }
  });
})();
